import { render, staticRenderFns } from "./DementiaInsurance.vue?vue&type=template&id=01b561f9&"
import script from "./DementiaInsurance.vue?vue&type=script&lang=js&"
export * from "./DementiaInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports